import { z } from 'zod';

export const RoleSchema = z.enum(['SUPER_ADMIN', 'CONTROLOR', 'ADMINISTRATOR', 'AJUTOR_ADMINISTRATOR']);
export type Role = z.infer<typeof RoleSchema>;

export const CurrencySchema = z.enum(['MDL', 'EUR']);
export type Currency = z.infer<typeof CurrencySchema>;

export const ExpenseStatusSchema = z.enum(['DRAFT', 'SUBMITTED', 'APPROVED', 'REJECTED']);
export type ExpenseStatus = z.infer<typeof ExpenseStatusSchema>;

export const LanguageSchema = z.enum(['ro', 'ru', 'en']);
export type Language = z.infer<typeof LanguageSchema>;

export const AuditActionSchema = z.enum([
  'CREATE',
  'UPDATE',
  'UPDATE_GEOMETRY',
  'DELETE',
  'LOGIN',
  'LOGOUT',
  'IMPORT',
  'ATTACH',
  'DETACH',
  'DEACTIVATE',
  'REACTIVATE',
  'ROLE_CHANGE',
  'PASSWORD_RESET',
  'RESTORE',
  'NOTIFY',
]);
export type AuditAction = z.infer<typeof AuditActionSchema>;

export const ImportSourceSchema = z.enum(['csv', 'xlsx', 'shapefile']);
export type ImportSource = z.infer<typeof ImportSourceSchema>;

export const ImportStatusSchema = z.enum(['PREVIEW', 'COMMITTED', 'FAILED', 'EXPIRED']);
export type ImportStatus = z.infer<typeof ImportStatusSchema>;

export const ImportModeSchema = z.enum(['skip_invalid', 'all_or_nothing']);
export type ImportMode = z.infer<typeof ImportModeSchema>;

export const CommentEntityTypeSchema = z.enum(['Parcel', 'PhotoRecord']);
export type CommentEntityType = z.infer<typeof CommentEntityTypeSchema>;

export const PolygonStatusSchema = z.enum(['IN_POLYGON', 'AUTO_ADJUSTED', 'NOT_ASSIGNED', 'MANUAL_ADJUSTED']);
export type PolygonStatus = z.infer<typeof PolygonStatusSchema>;

export const POLYGON_STATUS_COLORS: Record<string, string> = {
  IN_POLYGON: '#22c55e',
  AUTO_ADJUSTED: '#eab308',
  NOT_ASSIGNED: '#ef4444',
  MANUAL_ADJUSTED: '#f97316',
};

export const POLYGON_STATUS_LABELS: Record<string, { ro: string; ru: string; en: string }> = {
  IN_POLYGON: { ro: 'In poligon', ru: 'В полигоне', en: 'In polygon' },
  AUTO_ADJUSTED: { ro: 'Ajustat automat', ru: 'Авто-привязка', en: 'Auto adjusted' },
  NOT_ASSIGNED: { ro: 'Neasignat', ru: 'Не назначен', en: 'Not assigned' },
  MANUAL_ADJUSTED: { ro: 'Ajustat manual', ru: 'Ручная привязка', en: 'Manual adjusted' },
};
